import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

declare global {
  var dataLayer: Array<DataLayerObject>;
}

export interface DataLayerObject {
  event: string;
  page_path?: string;
  page_title?: string;

  // TODO: for form submit... put in own place?"
  formId?: string;
  formName?: string;
  submissionStatus?: string;
  // page?: Record<string, unknown>;
}

@Injectable({
  providedIn: 'root',
})
export class GoogleAnalyticsService {
  private analyticsEnabled = environment.analyticsEnabled;

  get DataLayerDefatults() {
    const date = new Date();
    const currentTimestamp = date.getTime();
    const pageModDate = date.toISOString();
    const pageUrl = globalThis.location?.href;
    const environment = 'bourne bespoke';
    const path = globalThis.location?.pathname;
    return {
      date,
      currentTimestamp,
      pageModDate,
      pageUrl,
      path,
      environment,
    };
  }
  constructor() {
    globalThis.dataLayer = globalThis.dataLayer || [];
  }

  createPageView(intent: string, extras?: DataLayerObject) {
    if (!this.analyticsEnabled) {
      console.warn('[GA] Analytics is disabled in this environment.');
      return;
    }
    const dataLayerObject: DataLayerObject = {
      event: 'pageview',
      page_path: globalThis.location?.pathname,
      page_title: globalThis.location?.pathname,
      ...extras,
      // page: {
      //   intent,
      //   ...this.DataLayerDefatults,
      //   ...extras,
      // },
    };

    globalThis.dataLayer.push(dataLayerObject);
    // console.log('[GA] Page view logged:', dataLayerObject);
  }
}
